// extracted by mini-css-extract-plugin
module.exports = {"carousel":"Carousel_carousel__RqX9m","slide-indicator":"Carousel_slide-indicator__tidli","selected":"Carousel_selected__fPtgv"};